import {
  initCartoResultat,
  showLoading,
} from '../common/carte/carte-resultat-util.js';
import { clampLines } from '../utils/utils.js';
import { init as initListing } from '../listing/listing.js';

import './etude.css';

const descriptionEl = document.querySelector('.etude-description-contenu');
if (descriptionEl) {
  clampLines(descriptionEl, 6, true);
}

let mapInitialized = false;
const initCarte = () => {
  if (!window.Carto || !window.Carto.etudeGeoRef) {
    return;
  }

  if (mapInitialized) {
    return;
  }

  // on appelle initCartoResultat seulement une fois
  // sinon la carte va être dupliquée
  mapInitialized = true;

  // On cache la zone de résultats pour éviter d'afficher "0 résultat" pendant la récupération des données
  const hiddenElements = document.querySelectorAll(
    '.carte-wrapper .carte-filtres-resultats, .carte-wrapper .carte-toggle-bouton',
  );
  hiddenElements.forEach((element) => (element.style.display = 'none'));

  document
    .querySelectorAll(
      '.search-results-list-actions [data-action="listing:display-mode"]',
    )
    .forEach((actionElement) =>
      actionElement.toggleAttribute('disabled', true),
    );

  const discardLoading = showLoading();
  initCartoResultat(async (map, loadFeatureForMap, displayResults) => {
    map
      .getView()
      .fit(
        [
          window.Carto.etudeGeoRef.minX,
          window.Carto.etudeGeoRef.minY,
          window.Carto.etudeGeoRef.maxX,
          window.Carto.etudeGeoRef.maxY,
        ],
        {
          padding: [40, 40, 40, 40],
        },
      );
    await loadFeatureForMap(
      map,
      null,
      window.Carto.etudeGeoRef?.dossierIds
        ? window.Carto.etudeGeoRef.dossierIds.split(',')
        : null,
      true,
    );
    // Mise à jour du panneau des résultats
    displayResults();

    discardLoading();

    // On annule le display: none réalisé plus tôt
    hiddenElements.forEach((element) => (element.style.display = null));

    [
      ...document.querySelectorAll(
        '.search-results-list-actions [data-action="listing:display-mode"]',
      ),
    ]
      .filter((actionElement) => actionElement.dataset.listingMode !== 'carte')
      .forEach((actionElement) => actionElement.removeAttribute('disabled'));
  });
};

const initDisplayCarteBtn = () => {
  const displayCarteBtn = document.querySelector(
    '.etude-dossiers .search-results-list-actions [data-action="listing:display-mode"]',
  );

  displayCarteBtn.addEventListener('click', () => initCarte());
};

const init = () => {
  const descriptionEl = document.querySelector('.etude-description-contenu');
  if (descriptionEl) {
    clampLines(descriptionEl, 6, true);
  }

  const etudeContainer = document.querySelector('.etude');
  const initialDisplayMode =
    document.querySelector('.etude').dataset.initialDisplayMode;
  initListing('.etude-dossiers', {
    initialDisplayMode,
    onDisplayModeChanged: (currentDisplayMode) => {
      etudeContainer.setAttribute('data-display-mode', currentDisplayMode);

      if (currentDisplayMode === 'carte') {
        initCarte();
      }
    },
  });

  // NO CHEEZBURGER
  if (!window.Carto || !window.Carto.etudeGeoRef) {
    return;
  }

  initDisplayCarteBtn();
};

init();
